// TODO: Remove when we use i18n
export const notEmptyMessage = "muss ausgefüllt werden";
